import { useState, useEffect } from 'react';
import VolumeIcon from 'components/shared/volume-icon';
import classNames from 'classnames';
import useIsMobile from 'hooks/utils/useIsMobile';
import { Range, getTrackBackground } from 'react-range';
import styles from './volume-control.module.scss';

const STEP = 0.01;
const MIN = 0;
const MAX = 1;

const VolumeControl = ({ volume, onVolumeChange, toggleMute, classes }) => {
  const isMobile = useIsMobile();
  const [values, setValues] = useState([volume]);
  const handleChange = newVolume => {
    setValues(newVolume);
    onVolumeChange(newVolume);
  };

  useEffect(() => {
    setValues([volume]);
  }, [volume]);

  // Only show the volume input slider on desktop devices
  // On mobile, the user can use the device volume buttons
  return (
    <div
      className={classNames(classes, styles.volumeToggle, { [styles.withVolumeSlider]: !isMobile })}
    >
      <div className={styles.volumeSliderWrapper}>
        <button
          onClick={toggleMute}
          type="button"
          aria-label="Toggle volume"
          className={styles.volumeButton}
        >
          <VolumeIcon volume={volume} />
        </button>

        <div className={styles.customVolumeSlider}>
          <Range
            values={values}
            className={styles.range}
            aria-label="Volume control slider"
            step={STEP}
            min={MIN}
            max={MAX}
            onChange={volume => handleChange(volume)}
            renderTrack={({ props, children }) => (
              <div
                role="button"
                tabIndex="-1"
                onMouseDown={props.onMouseDown}
                onTouchStart={props.onTouchStart}
                style={{
                  ...props.style,
                  height: '1rem',
                  display: 'flex',
                  width: '100%',
                }}
              >
                <div
                  ref={props.ref}
                  style={{
                    height: '0.5rem',
                    width: '100%',
                    borderRadius: '4px',
                    background: getTrackBackground({
                      values,
                      colors: ['#FFF', '#7e7e7e'],
                      min: MIN,
                      max: MAX,
                    }),
                    alignSelf: 'center',
                  }}
                >
                  {children}
                </div>
              </div>
            )}
            renderThumb={({ props }) => (
              <div
                {...props}
                aria-label="Volume control thumb"
                style={{
                  ...props.style,
                  height: '1.8rem',
                  width: '1.8rem',
                  borderRadius: '1.8rem',
                  backgroundColor: '#FFF',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  outline: 'none',
                }}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default VolumeControl;
